import React from 'react';
import { createPortal } from 'react-dom';
import { X, Trophy, Loader } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export default function TenderWonConfirmModal({ 
  isOpen,
  onConfirm, 
  onCancel, 
  isSaving,
  canConfirm = true,
  children 
}) {
  const modalContent = (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center z-[100] p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col overflow-hidden"
          >
            <div className="px-6 py-4 border-b flex justify-between items-center bg-emerald-50/50">
              <div>
                <h3 className="text-lg font-bold text-emerald-800 flex items-center gap-2">
                  <Trophy className="w-5 h-5 text-emerald-600" />
                  Confirm Winning Tender
                </h3>
                <p className="text-sm text-emerald-600 mt-1">Please review and confirm all details before marking this tender as Won.</p>
              </div>
              <button onClick={onCancel} className="p-2 hover:bg-emerald-100 rounded-full transition-colors">
                <X className="w-5 h-5 text-emerald-700" />
              </button>
            </div>
            
            <div className="p-6 overflow-y-auto flex-1 bg-slate-50">
              <div className="max-w-2xl mx-auto space-y-6">
                {children}
              </div>
            </div>

            <div className="px-6 py-4 border-t bg-white flex flex-col sm:flex-row justify-between items-center gap-3">
              <div className="text-xs text-amber-600 font-medium">
                {!canConfirm && "Please fill all required general and commercial details to confirm."}
              </div>
              <div className="flex gap-3">
                <button onClick={onCancel} disabled={isSaving} className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded-xl font-medium transition-colors disabled:opacity-50">
                  Cancel
                </button>
                <button onClick={onConfirm}
                  disabled={isSaving || !canConfirm}
                  className="px-6 py-2 text-sm bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl font-semibold transition-colors disabled:opacity-60 disabled:cursor-not-allowed flex items-center gap-2">
                  {isSaving ? <Loader className="w-4 h-4 animate-spin" /> : <>Confirm Win <Trophy className="w-4 h-4" /></>}
                </button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );

  return createPortal(modalContent, document.body);
}
